export enum AccountACL {
  ACCOUNT_UPDATE = 'ACCOUNT.UPDATE',
  CONTACT_VIEW = 'CONTACT.VIEW',
  CONTACT_SAVE = 'CONTACT.SAVE',
  CONTACT_DELETE = 'CONTACT.DELETE',
  TWOFA_APP_VIEW = '2FA_APP.VIEW',
  TWOFA_EMAIL_VIEW = '2FA_EMAIL.VIEW',
  PASSWORD_CHANGE_VIEW = 'PASSWORD_CHANGE.VIEW',
  PASSWORD_CHANGE_UPDATE = 'PASSWORD_CHANGE.UPDATE',
  PASSWORD_INFO_VIEW = 'PASSWORD_INFO.VIEW',
  PASSWORD_INFO_UPDATE = 'PASSWORD_INFO.UPDATE',
  PASSWORD_EXPIRATION_CONFIG_VIEW = 'PASSWORD_EXPIRATION_CONFIG.VIEW',
  PASSWORD_EXPIRATION_CONFIG_UPDATE = 'PASSWORD_EXPIRATION_CONFIG.UPDATE',
  TWOFA_APP_DELETE = '2FA_APP.DELETE',
  TWOFA_APP_PAIRING = '2FA_APP.PAIRING',
  TWOFA_APP_UPDATE = '2FA_APP.UPDATE',
  TWOFA_SMS_VIEW = '2FA_SMS.VIEW',
  TWOFA_SMS_CREATE = '2FA_SMS.CREATE',
  TWOFA_SMS_DELETE = '2FA_SMS.DELETE',
  TWOFA_SMS_PARENT_ACTIVE_VIEW = '2FA_SMS.PARENT_ACTIVE.VIEW',
  TWOFA_APP_WITH_CHILDREN_VIEW = '2FA_APP.WITH_CHILDREN.VIEW',
  ACCESSLOG_REPORT = 'ACCESSLOG.REPORT',
  ACCESSLOG_VIEW = 'ACCESSLOG.VIEW',
  CLIENT_API = 'CLIENT_API',
  PEC_PLUS_VIEW = 'PEC_PLUS.VIEW',
  COMUNICATION_SETT_VIEW = 'COMUNICATION_SETT.VIEW',
  DOCAPOSTE_VIEW = 'DOCAPOSTE.VIEW',
}
